import {
  AccountCircle,
  Assignment,
  CardMembership,
  EmojiEvents,
  Lock,
  People,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import { useMemo } from 'react';

import { SettingsSidebarItem } from 'shared/components/navigation';
import { ROUTES } from 'shared/constants';
import { useCurrentUser, useFeatureEnabled } from 'shared/hooks';

import { SettingsMobileNavbarList } from './SettingsMobileNavbarList';
import { SettingsMobileNavbarUserProfile } from './SettingsMobileNavbarUserProfile';

const MAIN_SIDEBAR_LIST_DATA = [
  {
    title: 'Account Information',
    icon: <AccountCircle />,
    route: ROUTES.user.settings.information,
  },
  {
    title: 'Sign-in & Security',
    icon: <Lock />,
    route: ROUTES.user.settings.security,
  },
];

const ADDITIONAL_SIDEBAR_LIST_DATA = [
  { title: 'Groups', icon: <People />, route: ROUTES.user.settings.groups },
  {
    title: 'Edit Public Profile',
    icon: <Assignment />,
    route: ROUTES.user.settings.profile,
  },
];

const ADMIN_MAIN_SIDEBAR_LIST_DATA = [
  {
    title: 'Account Information',
    icon: <AccountCircle />,
    route: ROUTES.admin.settings.information,
  },
];

export const SettingsMobileNavbar = ({ isAdminRoute = false }: { isAdminRoute: boolean }) => {
  const { user, loading: loadingUser } = useCurrentUser();
  const { enabled: showRewardingAccount } = useFeatureEnabled('rewardActions');
  const { enabled: showMemberships } = useFeatureEnabled('communityMarketplace');

  const items: SettingsSidebarItem[] = useMemo(() => {
    const items: SettingsSidebarItem[] = isAdminRoute
      ? ADMIN_MAIN_SIDEBAR_LIST_DATA
      : [...MAIN_SIDEBAR_LIST_DATA, ...ADDITIONAL_SIDEBAR_LIST_DATA];

    if (showRewardingAccount) {
      items.push({
        title: 'Rewards Account',
        icon: <EmojiEvents />,
        route: ROUTES.user.settings.rewarding,
      });
    }

    if (showMemberships) {
      items.push({
        title: 'My Memberships',
        icon: <CardMembership />,
        route: ROUTES.user.settings.memberships,
      });
    }

    return items;
  }, [showRewardingAccount, showMemberships]);

  return (
    <Box>
      <SettingsMobileNavbarUserProfile user={user} loading={loadingUser} />

      <SettingsMobileNavbarList listData={items} />
    </Box>
  );
};
